import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

class CommonRecordsNotFound extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNoRecords: false
        };
        this.timeoutRef = null;
    }

    componentDidUpdate(prevProps) {
        const prevLoading = prevProps.Action?.Loading?.dataTable;
        const currentLoading = this.props.Action?.Loading?.dataTable;
        const { rows } = this.props;

        if (prevLoading === true && currentLoading === false && (!rows || rows.length === 0)) {
            clearTimeout(this.timeoutRef);
            this.timeoutRef = setTimeout(() => {
                this.setState({ showNoRecords: true });
            }, 100);
        }

        if (currentLoading || (rows && rows.length > 0)) {
            clearTimeout(this.timeoutRef);
            if (this.state.showNoRecords) {
                this.setState({ showNoRecords: false });
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutRef);
    }

    render() {
        const { Action, rows } = this.props;
        const isLoading = Action?.Loading?.dataTable;
        const { showNoRecords } = this.state;

        if (typeof isLoading !== 'boolean') return null;

        if (isLoading) {
            return null;
        }

        if (showNoRecords) {
            return (
                <Row className="align-items-center">
                    <Col xs={8} className="title-sm text-muted title-wth-divider m-0">
                        <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-2"></i>
                        <span>ไม่พบรายการข้อมูล</span>
                    </Col>
                </Row>
            );
        }

        return null;
    }
}

export default CommonRecordsNotFound;
